import { render, staticRenderFns } from "./ShopPresetDetails.vue?vue&type=template&id=4625f72d"
import script from "./ShopPresetDetails.vue?vue&type=script&lang=js"
export * from "./ShopPresetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports